// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"261":"7ed26a26","453":"b8e4b7a5","549":"195c16e7","724":"0d950835","781":"7cd0bda3"}[chunkId] + ".chunk.js";
};